const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_8[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition1[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[10]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition2[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition3[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[9]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition4[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[1]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition5[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[8]",
        },        
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition6[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition7[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[7]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition7[1]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[11]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition8[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[3]",
        },

        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition9[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[6]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition10[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[4]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition13[1]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[12]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Condition13[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis1[5]",
        }
    ]
}

export default ssn ;